import React, { memo } from 'react';

import './fitment-error.scss';

function FitmentError() {
  return (
    <div styleName="error">
      <div styleName="message">Sorry, something went wrong.</div>
    </div>
  );
}

export default memo(FitmentError);
